import {
    AppBar,
    DialogTitle,
    DialogContent,
    TextField,
    Button,
    Toolbar,
    Typography,
    useTheme,
} from "@mui/material";
import { useState } from "react";
import { useErrorDisplay } from "../components/ErrorDisplay"
import { ExtractForSetError, GetUpsertIcon, IsEmpty } from "../Helpers";
import BusySpinner from "../components/BusySpinner";
import IconButtonEx, { IconButtonExProps } from "../components/IconButtonEx";
import { UpsertAction } from "../Enums";
import ProfileClient, { ProfileErrors } from "../apiClients/ProfileClient";
import { MobileFormStack, ResponsiveDialog, ResponsiveDialogHeader, StickyDialogActions } from "../components/responsive";
import ButtonEx from "../components/ButtonEx";
import CloseIcon from "@mui/icons-material/Close";
import useViewportMode from "../hooks/useViewportMode";

export interface ProfileUpsertProps extends Omit<IconButtonExProps, 'onClick'> {
    mode: UpsertAction;
    templateRevisionId: string;
    profileId?: string;
    onChange?: () => Promise<void>;
    onAdd?: (id: string) => Promise<void>;
    icon?: JSX.Element;
}

const ProfileUpsertPopup = ({ mode, templateRevisionId, profileId, onChange = async () => { }, onAdd = async () => { }, icon = GetUpsertIcon(mode), ...btnProps }: ProfileUpsertProps) => {
    const [ErrorDisplay, setError] = useErrorDisplay();
    const [busy, setBusy] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);
    const theme = useTheme();
    const viewport = useViewportMode();
    const [profile, setProfile] = useState('Profile1');

    const disableSave = IsEmpty(profile);

    const title = (mode === UpsertAction.Create) ? 'Create Profile' : `Edit Profile`;

    const handleSubmit = async () => {
        try {
            setBusy(true);

            if (mode === UpsertAction.Create) {
                await createProfile();
            }
            else if (mode === UpsertAction.Update) {
                // await new ProfileClient().Update(profileId, profile.Title);
                // await onChange();
            }

        } catch (error) {
            setError(error, (mode === UpsertAction.Create) ? ProfileErrors.Create : ProfileErrors.Update);
        }
        finally {
            setBusy(false);
            setOpen(false);
        }
    };

    const handleInputChange = e => {
        const { name, value } = e.target;
        setProfile(value);
    };

    const handleOpen = async () => {
        setOpen(true);
        await loadData();
    };

    const loadData = async () => {
        // try {
        //     setBusy(true);

        //     if (mode === UpsertAction.Update) {
        //         // let p = await new ProfileClient().GetSingle(profileId);
        //         // setProfile(p);
        //     }

        // } catch (error) {
        // //    setError(error, ProfileErrors.GetSingle);
        // }
        // finally {
        //     setBusy(false);
        // }
    };

    const createProfile = async () => {

        const cm = {
            SourceProfileId: profileId,
            ProfileName: profile
        }

        const apiResponse = await new ProfileClient().Create(templateRevisionId, cm);
        if (ExtractForSetError(apiResponse, ProfileErrors.Create, setError))
            return;

        await onAdd(apiResponse.Content);
    }

    return <>
        <ErrorDisplay />
        <IconButtonEx disabled={busy} hoverContent={title} size='small' onClick={handleOpen} {...btnProps}>{icon}</IconButtonEx>

        <ResponsiveDialog aria-labelledby="profile-upsert-title" open={open} fullWidth tabletFullScreen="never" PaperProps={{ sx: { overflow: 'hidden', '& > div': { flex: '1 1 auto', minHeight: 0, height: 'auto !important', display: 'flex', flexDirection: 'column' } } }}>
            <BusySpinner busy={busy}>
                {viewport.isDesktop ? <>
                    <AppBar sx={{ profile: 'relative' }}>
                        <Toolbar>
                            <IconButtonEx edge="start" color="inherit" onClick={() => setOpen(false)} aria-label="close"><CloseIcon /></IconButtonEx>
                            <Typography variant="h6" sx={{ marginLeft: theme.spacing(2), flex: 1 }}>{title}</Typography>
                            <ButtonEx autoFocus color="inherit" onClick={() => setOpen(false)}>close</ButtonEx>
                        </Toolbar>
                    </AppBar>
                    <DialogTitle id="profile-upsert-title" sx={{ margin: 0, padding: theme.spacing(2) }}>
                        <Typography variant="h6">{title}</Typography>
                    </DialogTitle>
                </> : (
                    <ResponsiveDialogHeader id="profile-upsert-title" title={title} onClose={() => setOpen(false)} sx={{ margin: 0, padding: theme.spacing(2) }} />
                )}
                <DialogContent dividers sx={{ padding: theme.spacing(2), overflowY: 'auto' }}>
                    <MobileFormStack tabletColumns={1} desktopColumns={1}>
                    <TextField label="Title" fullWidth
                        name="Title"
                        sx={{ marginBottom: theme.spacing(1) }}
                        error={IsEmpty(profile)}
                        size='small'
                        variant="outlined"
                        value={profile}
                        onChange={handleInputChange} />
                    </MobileFormStack>
                </DialogContent>
                <StickyDialogActions phoneLayout="stacked" sx={{ margin: 0, padding: theme.spacing(1) }}>
                    <Button onClick={() => setOpen(false)} variant='text' color='inherit'>Cancel</Button>
                    <Button disabled={disableSave} onClick={handleSubmit} variant='outlined' color='primary'>Submit</Button>
                </StickyDialogActions>
            </BusySpinner>
        </ResponsiveDialog>
    </>;
}

export default ProfileUpsertPopup;
